import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Shop from './views/Shop.vue';
import Product from './views/Product.vue';
import Cart from './views/Cart.vue';
import Favorites from './views/Favorites.vue';
import Checkout from './views/Checkout.vue';
import ThankYou from './views/ThankYou.vue';
import PaymentFaild from './views/PaymentFaild.vue';
import MultiPage from './views/MultiPage.vue';
import Faq from './views/Faq.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import ForgotPassword from './views/ForgotPassword.vue';
import ResetPassword from './views/ResetPassword.vue';
import MyAccount from './views/my-account/MyAccount.vue';
import Order from './views/my-account/Order.vue';
import About from './views/About.vue';
import Contact from './views/Contact.vue';
import Collection from './views/Collection.vue';
import Blog from './views/Blog.vue';
import BlogIndividual from './views/BlogIndividual.vue';
import CustomOrders from './views/CustomOrders.vue';
import CustomOrder from './views/CustomOrder.vue';
import CustomProduct from './views/CustomProduct.vue';
import HowItsMade from './views/HowItsMade.vue';
import Notify from './views/Notify.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [{
    path: '/:lang?',
    beforeEnter (to, from, next) {
      const lang = to.params.lang;
      if (!['en', 'hy', 'ru'].includes(lang)) {
        return next('/en' + to.path);
      }
      return next();
    },
    component: {
      template: '<router-view></router-view>'
    },
    children: [{
      path: '',
      name: 'home',
      component: Home
    },
    {
      path: 'about-us',
      name: 'about-us',
      component: About
    },
    {
      path: 'contacts',
      name: 'contacts',
      component: Contact
    },
    {
      path: 'shop/:taxonomy?/:term?',
      name: 'shop',
      component: Shop
    },
    {
      path: 'custom-orders',
      name: 'custom-orders',
      component: CustomOrders
    },
    {
      path: 'custom-orders/:job',
      name: 'custom-order',
      component: CustomOrder
    },
    {
      path: 'custom-product',
      name: 'custom-product',
      component: CustomProduct
    },
    {
      path: 'faq',
      name: 'faq',
      component: Faq
    },
    {
      path: 'product/:product',
      name: 'product',
      component: Product
    },
    {
      path: 'cart',
      name: 'cart',
      component: Cart
    },
    {
      path: 'favorites',
      name: 'favorites',
      component: Favorites
    },
    {
      path: 'checkout',
      name: 'checkout',
      component: Checkout
    },
    {
      path: 'thankyou',
      name: 'thankyou',
      component: ThankYou
    },
    {
      path: 'payment/faild',
      name: 'payment-faild',
      component: PaymentFaild
    },
    {
      path: 'login',
      name: 'login',
      component: Login
    },
    {
      path: 'register',
      name: 'register',
      component: Register
    },
    {
      path: 'forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: 'reset-password',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: 'pages/:page',
      name: 'pages',
      component: MultiPage
    },
    {
      path: 'account/order',
      name: 'order',
      component: Order
    },
    {
      path: 'account/:page/:action?',
      name: 'my-account',
      component: MyAccount
    },
    {
      path: 'collections/:page',
      name: 'collections',
      component: Collection
    },
    {
      path: 'blog',
      name: 'blog',
      component: Blog
    },
    {
      path: 'how-its-made',
      name: 'how-its-made',
      component: HowItsMade
    },
    {
      path: 'blog/:page',
      name: 'blog-individual',
      component: BlogIndividual
    },
    {
      path: 'about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: 'notify',
      name: 'notify',
      component: Notify
    },
    {
      path: '404',
      name: '404',
      component: NotFound
    },
    {
      path: '*',
      redirect: '404'
    }
    ]
  }],
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});
